/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AssignExperimentGroupsContainer_user$ref: FragmentReference;
declare export opaque type AssignExperimentGroupsContainer_user$fragmentType: AssignExperimentGroupsContainer_user$ref;
export type AssignExperimentGroupsContainer_user = {|
  +id: string,
  +joined: ?string,
  +numUsersRecruited: ?number,
  +$refType: AssignExperimentGroupsContainer_user$ref,
|};
export type AssignExperimentGroupsContainer_user$data = AssignExperimentGroupsContainer_user;
export type AssignExperimentGroupsContainer_user$key = {
  +$data?: AssignExperimentGroupsContainer_user$data,
  +$fragmentRefs: AssignExperimentGroupsContainer_user$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "AssignExperimentGroupsContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "joined",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "numUsersRecruited",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '8dc117c6588d81c70c7a6657a37d5577';
module.exports = node;
